export default function (instance) {
  return {
    signIn ({ customerEmail, adminUserName, adminPassword }) {
      return instance
        .post('/api/admin/signin', {
          customerEmail,
          adminUserName,
          adminPassword
        })
        .then(response => response.data)
    },

    getAdminActions (subscriptionNumber) {
      return instance
        .get(`/api/admin/${subscriptionNumber}/actions`)
        .then(response => response.data)
    },

    returnWithinRightToReturnDay (subscriptionNumber) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/actions/cancellation-within-right-to-return-day`)
        .then(response => response.data)
    },

    cancellationSubscriptiontrybuywithin (subscriptionNumber) {
      return instance
      .post(`/api/trybuy/${subscriptionNumber}/actions/trybuycancellation-within-right-to-return-day`,)
      .then(response => response.data)

    },
    
    cancellationSubscriptiontrybuyafter (subscriptionNumber) {
      return instance
      .post(`/api/trybuy/${subscriptionNumber}/actions/trybuycancellation-after-right-to-return-day`,)
      .then(response => response.data)
      
    },
    
    returnAfterRightToReturnDay (subscriptionNumber) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/actions/cancellation-after-right-to-return-day`)
        .then(response => response.data)
    },

    giveDiscountToNextPayment (subscriptionNumber, discountAmount) {
      return instance
        .post('/api/admin/action/giving-discount', {
          subscriptionNumber,
          discountAmount
        })
        .then(response => response.data)
    },

    returnAfterRightToReturnDayButNotCustomerFault (subscriptionNumber, cancellationDate) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/actions/cancellation-after-right-to-return-day-not-fault?cancellationDate=${cancellationDate}`)
        .then(response => response.data)
    },

    Reshipping (subscriptionNumber, { option }) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/actions/reshipping?subscriptionNumber`, { option })
        .then(response => response.data)
    },

    tryBuyReturnWithinRightToReturnDay (subscriptionNumber) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/try-buy/actions/cancellation-within-right-to-return-day`)
        .then(response => response.data)
    },

    tryBuyReturnAfterRightToReturnDay (subscriptionNumber) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/try-buy/actions/cancellation-after-right-to-return-day`)
        .then(response => response.data)
    },

    tryBuyReturnAfterRightToReturnDayButNotCustomerFault (subscriptionNumber, cancellationDate) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/try-buy/actions/cancellation-after-right-to-return-day-not-fault?cancellationDate=${cancellationDate}`)
        .then(response => response.data)
    },
    replenishmentReturnWithinRightToReturnDay (subscriptionNumber) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/replenishment/actions/cancellation-within-right-to-return-day`)
        .then(response => response.data)
    },

    replenishmentReturnAfterRightToReturnDayButNotCustomerFault (subscriptionNumber, cancellationDate) {
      return instance
        .post(`/api/admin/${subscriptionNumber}/replenishment/actions/cancellation-after-right-to-return-day-not-fault?cancellationDate=${cancellationDate}`)
        .then(response => response.data)
    }
  }
}
